const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');

/**
 * Defines the Survey Host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('surveyHost', ['Application', 'Authorization','Surveys', 'Analyze', '$q', '$translate', function (Application, Authorization, Surveys, Analyze, $q, $translate) {
    return {
        restrict: 'E',
        scope: {},
        template: require('../../templates/directives/survey-host.html'),
        controller: ['$scope', function ($scope) {
            var self = this;
            var routeParameters = Application.navigation.getRouteParameters();
            self.user = Authorization.getAuthToken().user;

            self.activeTab = 'results';
            self.changeTab = function (tab) {
                self.activeTab = tab
            };

            self.resetForFilter = function() {
              self.info.allResults = [];
              self.info.resultsByQuestion = {};
            }
            self.allResultsLink = `${Application.API}/learn/v3/surveys/${routeParameters.id}/responses-csv?authtoken=${Authorization.getAuthToken().authtoken}`;

            self.filteredResultsFullUrl = `${Application.API}/learn/v3/surveys/${routeParameters.id}/responses-csv?authtoken=${Authorization.getAuthToken().authtoken}`;
            self.filteredResultsLink = '';
            self.identifiersAssigned = false;

            self.info = {
                loading: false,
                totals: {
                    submitted: 0,
                    viewed: 0
                },
                allResults: [],
                associatedContentIds: [],
                associatedContentSelections: [{name: 'All Content', value: null}],
                resultsByQuestion: {},
                questionData: [],
                questionIds: [],
                surveyTitle: '',
                identifiedResultsKey: {},
                selectedSubmissionContent: null,
                goToSurvey: function() {
                    Application.navigation.goTo('view/survey/' + routeParameters.id)
                },
                editSurvey: function() {
                    Application.navigation.goTo('edit/survey/' + routeParameters.id)
                },
            };

            self.comms = {
                initializing: false,
                initialize: function() {
                    self.comms.initializing = true;
                    $q.all([
                        self.comms.getSurveyResults(),
                        self.comms.getSurvey()
                    ]).then(async function(data) {
                        self.info.surveyTitle = data[1].title;
                        self.info.questionIds = data[1].questions.map(question => question._id);
                        await self.comms.getTotals();
                        if (data[0].length){
                          self.info.allResults = data[0];
                            self.comms.assignIdentifiers();
                            self.comms.formatResults();
                            self.comms.getContentAssociations();
                        }
                        self.comms.initializing = false;
                    }).catch(function(error) {
                        console.log('error: ', error)
                        self.comms.initializing = false;
                    });
                },
                getSurveyResults: function(contentId = null) {
                  return Surveys.getResults({subresource: routeParameters.id, contentId}).$promise;
                },
                getSurvey: function () {
                  return Surveys.get({subresource: routeParameters.id}).$promise;
                },
                getTotals: async function(contentId = null) {
                  const viewQuery = {content: routeParameters.id, content_type: 'survey', created_at: {gte: moment().subtract(30, 'days').toDate()}}
                  const countQuery = {surveyId: routeParameters.id};
                  if (contentId) {
                    countQuery.contentId = contentId;
                  }
                  const views = await Analyze.viewCount(viewQuery).$promise;
                  const count = await Surveys.count(countQuery).$promise;
                  self.info.totals.viewed = views.count;
                  self.info.totals.submitted = count.totalSubmissions;
                },
                assignIdentifiers: function() {
                  const sortedResults = self.info.allResults.sort((a, b) => new Date(a.date_completed) - new Date(b.date_completed));
                  sortedResults.forEach((result, index) => {
                    self.info.identifiedResultsKey[result._id] = index + 1;
                  })
                  self.identifiersAssigned = true;
                },
                formatResults: function () {
                  self.info.questionData = [];
                  self.info.allResults.forEach((userAnswer) => {
                    userAnswer.submissionResults = {};
                    userAnswer.results.forEach((answer) => {
                      const questionId = answer.question._id;
                      if (self.info.resultsByQuestion[questionId]) {
                        const parsedAnswer = self.comms.parseResults(answer, answer.answer)
                        userAnswer.submissionResults[questionId] = parsedAnswer.forSubmissionTab;
                        self.info.resultsByQuestion[questionId].answers.push(parsedAnswer.newAnswer);
                      } else {
                        if (!self.info.questionIds.includes(questionId)) {
                          return;
                        }
                        const choices = answer.question.choices.map(choiceObj => choiceObj.text || choiceObj.value);
                        const newDataObj = {
                          choices: choices || [],
                          answers: [],
                          title: answer.question.title || answer.question.question_json.name,
                          type: answer.question.type
                        }
                        const parsedAnswer = self.comms.parseResults(answer, answer.answer)
                        userAnswer.submissionResults[questionId] = parsedAnswer.forSubmissionTab;
                        self.info.questionData.push({ title: newDataObj.title, id: questionId });
                        self.info.resultsByQuestion[questionId] = newDataObj;
                        self.info.resultsByQuestion[questionId].answers.push(parsedAnswer.newAnswer);
                      }
                    })
                  })
                },
                parseResults: function (submission, answers) {
                    let newAnswer;
                    let otherAnswer = false;
                    switch (submission.question.type) {
                    case 'checkbox':
                      let submissionWithOtherAnswers = [];
                      newAnswer = [];
                      for (const answer of answers) {
                        const selected = submission.question.choices.find(choice => choice.value === answer);
                        if (!!selected) {
                          newAnswer.push(selected.text);
                          submissionWithOtherAnswers.push(selected.text);
                          continue;
                        }
                        const otherChoice = submission.question.choices.find(c => c.value === 'Other');
                        if (!!otherChoice) {
                          otherAnswer = true;
                          newAnswer.push(otherChoice.text); // 'Other' answers will not match a selection
                          submissionWithOtherAnswers.push(answer);
                        }
                      }
                      return {
                        newAnswer,
                        forSubmissionTab: {
                          questionId: submission.question._id,
                          answer: `"${otherAnswer ? submissionWithOtherAnswers.join('","') : newAnswer.join('", "')}"`
                        }
                      }
                        
                    case 'radiogroup':
                      const selected = submission.question.choices.find(choice => choice.value === answers);
                      if (!!selected) {
                        newAnswer =  selected.text;
                      } else if (!!submission.question.choices.find(c => c.value === 'Other')) {
                        otherAnswer = true;
                        newAnswer = submission.question.choices.find(c => c.value === 'Other').text; // 'Other' answers will not match a selection
                      }                    
                      return {
                        newAnswer,
                        forSubmissionTab: {
                          questionId: submission.question._id,
                          answer: otherAnswer ? answers : newAnswer
                        }
                      }
                    default:
                        return {
                          newAnswer: answers, 
                          forSubmissionTab: {
                            questionId: submission.question._id,
                            answer: answers
                          }
                        };
                    };
                },
                getContentAssociations: function() {
                    self.info.allResults.forEach((userAnswer) => {
                      if (!self.info.associatedContentIds.includes(userAnswer.content)) {
                        self.info.associatedContentIds.push(userAnswer.content);
                        self.info.associatedContentSelections.push({name: userAnswer.contentTitle, value: userAnswer.content});
                      }
                  });
                },
                filterResults: async function(contentId) {
                  self.resetForFilter();
                  self.info.allResults  = await self.comms.getSurveyResults(contentId);
                  self.comms.formatResults();
                  await self.comms.getTotals(contentId);
                  $scope.$apply();
                }
            };
            
            $scope.$watch('surveyHost.info.selectedSubmissionContent', async function (newVal, oldVal) {
              if (newVal === undefined || newVal === oldVal) {
                return;
              }
              // newVal being 'null' will query all again
              await self.comms.filterResults(newVal);
              if (newVal !== null) {
                self.filteredResultsLink = `${self.filteredResultsFullUrl}&contentId=${newVal}`;
                $scope.$apply();
              }
            });

            $translate([
                'hostSurveys.totalSubmissions',
                'edit.surveys.errorCreated',
                'overviewContent.past_30_days'
            ]).then(function(translations) {
                self.translations = translations;
                self.comms.initialize();
            });
        }],
        controllerAs: 'surveyHost'
    }
}]);
